/* eslint-disable @typescript-eslint/no-explicit-any */
import { initDependencies, setupDependencies } from './app';

setupDependencies();

initDependencies();

const { runApp } = require('./services/runApp');
runApp();

__webpack_public_path__ = window.__countryside_project_card_frontend_public_path__;

if ((module as any).hot) {
  (module as any).hot.accept();
}
